<template>
    <AppHeaderDropdown right no-caret show>
        <template slot="header">
            <b-nav-item class="d-md-down-none">
                <i class="icon-organization" style="color: #fff;"></i>
            </b-nav-item>
        </template>
        <template slot="dropdown">
            <b-dropdown-item disabled><i class="fa fa-sitemap" />{{current.value_2}}</b-dropdown-item>
            <b-dropdown-item v-for="item in suites" :key="item.id" v-on:click="triggerLogOn(item.id)"><i class="fa fa-sitemap" style="color: black"/>{{item.value_2}}</b-dropdown-item>
        </template>
    </AppHeaderDropdown>
</template>

<script>
    import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
    export default {
        name: 'ChangeSuiteDropdown',
        components: {
            AppHeaderDropdown
        },
        props:{
            current: {
                type: Object,
                default: () => {}
            },
            suites: {
                type: Array,
                default: () => []
            },

        },
        methods: {
            triggerLogOn(id) {
                this.$emit('log-on', id);
            }
        }
    }
</script>

<style>
    .dropdown-menu.dropdown-menu-right.show {
        transform: none !important;
        top: 100% !important;
        left: auto !important;
        will-change: unset !important;
    }
</style>
